/* Pastilles de couleur dans les boutons d'option Couleur / Finition des fiches produits.
   Valeur connue telle quelle (« doré », « rose-fonce »…) : sa couleur. Valeur composée (« doré violet vert ») :
   une pastille partagée entre les couleurs reconnues, dans l'ordre. Rien de reconnu : pastille neutre. */
(function () {
  var C = {
    dore: '#dcb977', or: '#dcb977', argente: '#cfd2d6', argent: '#cfd2d6', mixte: null, bronze: '#b07a46', ambre: '#f2b24a',
    champagne: '#f1dcb0', noir: '#1d1a1b', blanc: '#ffffff', 'blanc-casse': '#f4efe6', gris: '#9a9a9e', beige: '#e3d1b2',
    camel: '#c08a4f', marron: '#6f4a2f', rose: '#f2a3b7', 'rose-clair': '#f8cdd8', 'rose-fonce': '#d4567f', fuschia: '#d81b72',
    framboise: '#b8315a', corail: '#f47a63', rouge: '#c8322f', orange: '#f08a2c', jaune: '#f3d04a', vert: '#3f9b5b',
    'vert-d-eau': '#a8dcc9', bleu: '#3b74d1', 'bleu-ciel': '#a9d2f3', turquoise: '#35c0c5', 'bleu-turquoise': '#35c0c5',
    'bleu-fonce': '#1f3a7a', marine: '#1b2a52', 'bleu-marine': '#1b2a52', violet: '#7c4ab3', lilas: '#c9b1e6', mauve: '#b784a7',
    transparent: '#eef3f8', creme: '#f6ecd6', nude: '#e8c4a8', taupe: '#8b7d73', kaki: '#6b6b3a', bordeaux: '#7a1f2b',
    fushia: '#d81b72', fuchsia: '#d81b72', amethyste: '#9966cc', howlite: '#e9e9ec', agathe: '#b9b2a8', agate: '#b9b2a8',
    jean: '#5b7fa8', jeans: '#5b7fa8', clair: '#f1e3d3', fonce: '#7a5a44', grise: '#9a9a9e', fluo: '#ff5fa2'
  };
  /* accords : « dorée », « roses », « bleues », « blanche »… ramenés à la forme de base */
  var BASE = { doree: 'dore', dorees: 'dore', dores: 'dore', argentee: 'argente', argentees: 'argente', argentes: 'argente',
    roses: 'rose', rouges: 'rouge', bleus: 'bleu', bleue: 'bleu', bleues: 'bleu', verts: 'vert', verte: 'vert', vertes: 'vert',
    blanche: 'blanc', blanches: 'blanc', blancs: 'blanc', noire: 'noir', noires: 'noir', noirs: 'noir', violette: 'violet',
    violets: 'violet', jaunes: 'jaune', oranges: 'orange', grises: 'grise', marrons: 'marron', beiges: 'beige', multicolores: 'multicolore' };
  var SPECIAL = {
    mixte: 'linear-gradient(90deg,#dcb977 50%,#cfd2d6 50%)',
    multicolore: 'conic-gradient(#e94f6a,#f2cf3a,#4fb36c,#3b82d6,#8a55c8,#e94f6a)',
    holographique: 'conic-gradient(#f9c6d8,#c6e2f9,#d9f9c6,#f9f0c6,#f9c6d8)',
    leopard: 'radial-gradient(circle,#3b2a1a 22%,transparent 24%) 0 0/6px 6px,#d9a066',
    zebre: 'repeating-linear-gradient(45deg,#1d1a1b 0 3px,#ffffff 3px 6px)',
    raye: 'repeating-linear-gradient(90deg,#3b74d1 0 3px,#ffffff 3px 6px)',
    tigre: 'repeating-linear-gradient(45deg,#1d1a1b 0 2px,#e88a2a 2px 6px)',
    geometriques: 'conic-gradient(#e94f6a 0 25%,#f2cf3a 0 50%,#3b82d6 0 75%,#4fb36c 0)'
  };
  function norm(t) { return String(t).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z]+/g, '-').replace(/^-|-$/g, ''); }
  function bg(handle) {
    var h = norm(handle);
    if (SPECIAL[h]) return SPECIAL[h];
    if (C[h]) return C[h];
    var w = h.split('-').map(function (x) { return BASE[x] || x; }), cols = [], i = 0;
    if (w.length === 1 && C[w[0]]) return C[w[0]];
    while (i < w.length) {
      var two = w[i] + '-' + w[i + 1], three = two + '-' + w[i + 2];
      if (C[three]) { cols.push(C[three]); i += 3; }
      else if (C[two]) { cols.push(C[two]); i += 2; }
      else if (SPECIAL[w[i]]) { return SPECIAL[w[i]]; }
      else { if (C[w[i]]) cols.push(C[w[i]]); i += 1; }
    }
    cols = cols.filter(function (c, k) { return c && cols.indexOf(c) === k; }).slice(0, 4);
    if (!cols.length) return null;
    if (cols.length === 1) return cols[0];
    var step = 100 / cols.length;
    return 'linear-gradient(90deg,' + cols.map(function (c, k) { return c + ' ' + (k * step) + '% ' + ((k + 1) * step) + '%'; }).join(',') + ')';
  }
  function paint(root) {
    /* Par option (groupe de boutons) : pastilles seulement si au moins 60 % des choix sont des couleurs,
       sinon aucune (évite un mélange de boutons avec et sans pastille sur une option « Modèle » par exemple) */
    var groups = [];
    (root || document).querySelectorAll('.ivg-vdot[data-ivg-color]:not([data-ivg-done])').forEach(function (d) {
      var g = d.closest('fieldset') || d.parentNode.parentNode;
      if (groups.indexOf(g) < 0) groups.push(g);
    });
    groups.forEach(function (g) {
      var dots = [].slice.call(g.querySelectorAll('.ivg-vdot[data-ivg-color]'));
      var bgs = dots.map(function (d) { return bg(d.dataset.ivgColor); });
      var ok = bgs.filter(Boolean).length / (dots.length || 1) >= 0.6;
      dots.forEach(function (d, k) {
        if (ok && bgs[k]) { d.style.background = bgs[k]; d.style.display = ''; } else d.style.display = 'none';
        d.dataset.ivgDone = '1';
      });
    });
  }
  window.ivgSwatchBg = bg;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { paint(); }); else paint();
  /* Le thème remplace le sélecteur quand on change de variante */
  new MutationObserver(function () { paint(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
